export const exhibitions = [
  {
    title: "Cloud Play",
    venue: "Hecho a Mano",
    location: "Santa Fe, NM",
    dates: "July 3 – August 2, 2026",
    url: "https://hechoamano.org/show/hecho-a-mano-jasmine-venes-cloud-play",
    description: "A window installation of new work",
    image: "/images/arch_sculpture/1.jpeg",
    current: true,
  },
  {
    title: "SURFACE: Emerging Artists of NM",
    venue: "Harwood Art Center",
    location: "Albuquerque, NM",
    dates: "June 11 – July 25, 2026",
    url: "https://www.harwoodartcenter.org/current-exhibitions/surface-emerging-artists-of-nm-6/",
    description: "Annual juried group exhibition",
    image: "/images/stair_shadow_1/1.jpeg",
    current: true,
  },
  {
    title: "Regalos Group Show",
    venue: "Hecho Gallery",
    location: "Santa Fe, NM",
    dates: "December 2023",
  },
  {
    title: "Skin Deep Group Exhibition",
    venue: "New Mexico Art League",
    location: "Albuquerque, NM",
    dates: "August 2023",
  },
  {
    title: "Regalos Group Show",
    venue: "Hecho Gallery",
    location: "Santa Fe, NM",
    dates: "December 2022",
  },
];

export const currentExhibitions = exhibitions.filter((e) => e.current);
export const pastExhibitions = exhibitions.filter((e) => !e.current);
